import "./NewsGallery.css";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAllNews,
  getAPIURL,
  createNews,
  getImageUrl,
} from "../../api/newsGallery";
import { UserContext } from "../../contexts/CurrentUserContext";
import CreateNewsPopup from "./CreateNewsPopup/CreateNewsPopup";
import NewsDetailPopup from "./NewsDetailPopup/NewsDetailPopup";

// Импорт изображений
import img1 from "../../images/mainGallery/15.jpg";
import img2 from "../../images/mainGallery/5.JPG";
import img3 from "../../images/mainGallery/10.jpg";
import img4 from "../../images/mainGallery/7.jpg";
import img5 from "../../images/mainGallery/1.JPG";
import img6 from "../../images/mainGallery/4.JPG";

// Экспортируем объект images
export const images = {
  "15.jpg": img1,
  "5.JPG": img2,
  "10.jpg": img3,
  "7.jpg": img4,
  "1.JPG": img5,
  "4.JPG": img6,
};

function NewsGallery() {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const [news, setNews] = useState([]);
  const [isCreatePopupOpen, setIsCreatePopupOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const newsData = await getAllNews();
        setNews(newsData);
      } catch (error) {
        console.error("Ошибка при загрузке новостей:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchNews();
  }, []);

  const recentNews = news.slice(0, 6);

  // Проверка на доступ к созданию новостей (замените "НОВОСТИ" на ваш уровень доступа)
  const hasCreateAccess = userData?.access_levels?.some(
    (level) => level.name === "АДМС" || level.name === "ПУБ"
  );

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleMoreClick = () => {
    navigate("/news");
  };

  const handleCreateClick = () => {
    setIsCreatePopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsCreatePopupOpen(false);
  };

  const handleCreateNews = async (newsData) => {
    try {
      const formData = new FormData();
      formData.append("title", newsData.title);
      formData.append("content", newsData.content);

      if (newsData.images && newsData.images.length > 0) {
        newsData.images.forEach((image) => {
          formData.append("images", image);
        });
      }

      // Отладка - проверим содержимое FormData перед отправкой
      console.log("Подготовленные данные для отправки:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }

      await createNews(formData);
      const updatedNews = await getAllNews();
      setNews(updatedNews);
      setIsCreatePopupOpen(false);
    } catch (error) {
      console.error("Ошибка при создании новости:", error);
      throw new Error(
        `Не удалось создать новость: ${error.message}. Пожалуйста, проверьте введенные данные и попробуйте снова.`
      );
    }
  };

  const handleNewsClick = (news) => {
    setSelectedNews(news);
  };

  const handleCloseNewsDetail = () => {
    setSelectedNews(null);
  };

  return (
    <section className="news-gallery">
      <div className="news-gallery__header">
        <h2 className="news-gallery__title">Новости компании</h2>
      </div>
      <div className="news-gallery__grid">
        {recentNews.map((item, index) => (
          <article
            key={item.id}
            className={`news-item ${index === 0 ? "news-item--featured" : ""}`}
            onClick={() => handleNewsClick(item)}
          >
            <div className="news-item__image-container">
              <img
                className="news-item__image"
                src={item.image_urls[0]}
                alt={item.title}
              />
            </div>
            <div className="news-item__content">
              <div className="news-item__date">
                {formatDate(item.created_at)}
              </div>
              <h3 className="news-item__title">{item.title}</h3>
              <p className="news-item__text">{item.content}</p>
            </div>
          </article>
        ))}
      </div>
      <div className="news-gallery__buttons">
        <button className="news-gallery__more-button" onClick={handleMoreClick}>
          Все новости
        </button>
        {hasCreateAccess && (
          <button
            className="news-gallery__create-button"
            onClick={handleCreateClick}
          >
            Создать
          </button>
        )}
      </div>
      <CreateNewsPopup
        isOpen={isCreatePopupOpen}
        onClose={handleClosePopup}
        onSubmit={handleCreateNews}
      />
      <NewsDetailPopup
        isOpen={selectedNews !== null}
        onClose={handleCloseNewsDetail}
        news={selectedNews}
        images={images}
      />
    </section>
  );
}

export default NewsGallery;
